import { render, staticRenderFns } from "./SubcategoriesModal.vue?vue&type=template&id=67d9458e&scoped=true&"
import script from "./SubcategoriesModal.vue?vue&type=script&lang=js&"
export * from "./SubcategoriesModal.vue?vue&type=script&lang=js&"
import style0 from "./styles/SubcategoriesModal.scss?vue&type=style&index=0&id=67d9458e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d9458e",
  null
  
)

export default component.exports